module.exports = __webpack_public_path__ + "static/media/RoboCozinheiro.9586bec8.svg";